import React from 'react';
import { Chart as ChartJS, defaults } from "chart.js/auto";
import { Bar, Doughnut, Line } from "react-chartjs-2";

const Charts = () => {
    const existingEntries = JSON.parse(localStorage.getItem('codingEntries')) || [];
    console.log({ existingEntries });

    const chartsData = existingEntries.map(entry => ({
        date: entry.date,
        totalPoints: entry.totalPoints
    }));
    console.log({ chartsData });

    const dateArray = chartsData.map(entry => entry.date);

    const today = new Date();
    const oneWeekAgo = new Date(today);
    oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);


    const datesWithinOneWeek = dateArray.filter(dateString => {
        const [day, month, year] = dateString.split('/').map(Number);
        // Month in JavaScript Date object is 0-indexed, so we subtract 1 from the month
        const entryDate = new Date(year, month - 1, day);
        return entryDate >= oneWeekAgo && entryDate <= today;
    });

    console.log({ datesWithinOneWeek });

    // Function to make an array of  the data of datesWithinOneWeek from chartsData

    const newChartDataWithinOneWeek = chartsData.filter(entry => datesWithinOneWeek.includes(entry.date));

    console.log({ newChartDataWithinOneWeek });


    const getCurrentDateRange = () => {
        const currentDate = new Date();
        const dates = [];

        // Loop to get dates for the past 7 days
        for (let i = 6; i >= 0; i--) {
            const date = new Date(currentDate);
            date.setDate(currentDate.getDate() - i);
            dates.push(date);
        }

        return dates;
    };


    // Function to format date as "dd/mm/yyyy"
    const formatDate = (date) => {
        const day = date.getDate();
        const month = date.getMonth() + 1;
        const year = date.getFullYear();

        // Padding day and month with leading zeros if necessary
        const formattedDay = day < 10 ? '0' + day : day;
        const formattedMonth = month < 10 ? '0' + month : month;

        return `${formattedDay}/${formattedMonth}/${year}`;
    };

    // Function to check if a date exists in an array of objects and return the corresponding totalPoints
    const getTotalPoints = (date, chartData) => {
        const entry = chartData.find(entry => entry.date === date);
        return entry ? entry.totalPoints : 0;
    };

    // Assuming getCurrentDateRange() returns an array of Date objects
    const dates = getCurrentDateRange();

    // Formatting each date in the array
    const formattedDates = dates.map(date => formatDate(date));

    // Create finalChartData object
    const finalChartData = formattedDates.map(date => ({
        date: date,
        totalPoints: getTotalPoints(date, newChartDataWithinOneWeek)
    }));

    console.log({ finalChartData });




    // Example data for charts
    const barChartData = {
        labels: finalChartData.map(entry => entry.date),
        datasets: [
            {
                label: 'Total Points',
                data: finalChartData.map(entry => entry.totalPoints),
                backgroundColor: [
                    "rgba(43, 63, 229, 0.8)",
                    "rgba(250, 192, 19, 0.8)",
                    "rgba(253, 135, 135, 0.8)",
                    "rgba(43, 63, 229, 0.8)",
                    "rgba(250, 192, 19, 0.8)",
                    "rgba(253, 135, 135, 0.8)",
                    "rgba(43, 63, 229, 0.8)",
                ],
            },
        ],
        borderRadius: 5,
    };

    const lineChartData = {
        labels: finalChartData.map(entry => entry.date),
        datasets: [
            {
                label: 'Total Points',
                data: finalChartData.map(entry => entry.totalPoints),
            },
        ],
        borderRadius: 5,
    };

    return (
        <div
            style={{
                display: "flex",
                gap: "2rem",
                padding: "2rem",
            }}
        >
            <div
                style={{
                    width: "50%",
                    background: "#f5f5f5",
                    padding: ".5rem 1rem"
                }}
            >
                <h2>Bar Chart</h2>
                <Bar data={barChartData} />
            </div>
            <div
                style={{
                    width: "50%",
                    background: "#f5f5f5",
                    padding: ".5rem 1rem"
                }}
            >
                <h2>Line Chart</h2>
                <Line data={lineChartData} />
            </div>
        </div>
    );
};

export default Charts;
